<!DOCTYPE html>
<div  class="corner-img-1">
  <img class="img-1" src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/assets%2Fcorner-1.svg?alt=media&token=c2fb32c4-e3b3-4c80-b29a-b83c30bf02df" alt="" />
  <img class="img-1" src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/assets%2Fcorner-2.svg?alt=media&token=886276e0-225b-4bac-a526-a78e334bcf72" alt="" />
  <div  class="voucher-container">
    <div fxFlex="6"></div>
    <div fxFlex="14" class="ion-align-self-center">
      <p class="emoji-gift-cone"><img src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/assets%2Fcone.svg?alt=media&token=6ac79a4c-1980-4378-8601-e0015ddd465d" alt="" /></p>
    </div>
    <div fxFlex="15">
      <h2 class="text-sent">{{ "voucher-dialog.redeemed" | translate }}</h2>
      <p class="password-sent-confirmation">
        {{ voucherSuccessResponse?.Voucher_description!=''?voucherSuccessResponse?.Voucher_description:'voucher-dialog.Ace' | translate }}
      </p>
    </div>
    <div fxFlex="20" class="back-login">
      <ion-button expand="block" color="medium" class="capsule-btn common-margin" type="submit" (click)="viewTickets()">
        <!-- {{ voucherSuccessResponse?.button_label | uppercase }} -->
        {{
          voucherSuccessResponse?.paid_button_label
            ? (voucherSuccessResponse?.paid_button_label | uppercase)
            : (voucherSuccessResponse?.button_label | uppercase)
            || ("voucher-dialog.button_label" | translate)
        }}
      </ion-button>
    </div>

    <div fxFlex="5">
      <h1 class="back-link" (click)="backToVouchers()">{{ "voucher-dialog.Back" | translate }}</h1>
    </div>
  </div>
</div>
